import { REPORT_TYPE_DEAL_TASK_DUE_DILIGENCE_STATUS } from '../../constants/entity/report-types';

const ReportValidator: Validator = (values: FormValues): ValidationErrors => {
  const errors: ValidationErrors = {};

  const reportRequiredFields: string[] = [
    'reportFormat',
  ];

  if (values.reportData) {
    const isDealRequired: boolean = values.reportData.type
      && values.reportData.type === REPORT_TYPE_DEAL_TASK_DUE_DILIGENCE_STATUS;

    if (!errors.reportData) {
      errors.reportData = {};
    }

    reportRequiredFields.forEach((field: string): void => {
      if (!values.reportData[field] || !values.reportData[field].toString().trim()) {
        errors.reportData[field] = 'Required';
      }
    });

    if (values.reportData.fromDate && values.reportData.toDate
      && new Date(values.reportData.fromDate) > new Date(values.reportData.toDate)) {
      errors.reportData.toDate = 'Date To cannot be less than Date From';
    }

    if (isDealRequired && (!values.reportData.deals || !values.reportData.deals.length)) {
      errors.reportData.deals = 'Required';
    }
  }

  if (errors.reportData && !Object.keys(errors.reportData).length) {
    delete errors.reportData;
  }

  return errors;
};

export default ReportValidator;
